export default __webpack_public_path__ + "static/events-badge-688d0b57a3fa5546ee5e31e00fc14c23.svg";